import { toast } from "react-toastify";

export const showSuccessToast = (message,autoClose = true) => {
  toast.success(message, {
    position: "top-right",
    autoClose: autoClose ? 3000 : false,
  });
};

export const showErrorToast = (message,autoClose = true) => {
  toast.error(message, {
    position: "top-right",
    autoClose: autoClose ? 3000 : false,
  });
};
